import type {PaymentWay} from '@rocket-ui/lk-api';

export type RegistrationPaymentMethod = PaymentWay['type'];

export type PaymentMethodOption = {
	value: RegistrationPaymentMethod;
	label: string;
};

export const PAYMENT_METHOD_OPTIONS: PaymentMethodOption[] = [
	{value: 'sbp_account', label: 'По номеру телефона (СБП)'},
	{value: 'bank_card', label: 'По номеру карты'},
	{value: 'executor_account', label: 'По номеру счёта'},
	{value: 'executor_account/swift', label: 'На иностранный счёт'},
];
